(() => {
  if (window.__ugHomepageBound) return;
  window.__ugHomepageBound = true;
  document.addEventListener("click", event => {
    const button = event.target.closest("[data-ug-video-start]");
    if (!button) return;
    const shell = button.closest(".ug-video-shell");
    if (!shell || !/^\d{15,25}$/.test(shell.dataset.ugVideoId || "")) return;
    const url = shell.dataset.ugVideoUrl;
    const iframe = document.createElement("iframe");
    iframe.title = shell.dataset.ugVideoTitle;
    iframe.src = `https://www.tiktok.com/player/v1/${shell.dataset.ugVideoId}?autoplay=1&rel=0&description=0&controls=1&muted=0`;
    iframe.allow = "autoplay; fullscreen; encrypted-media; picture-in-picture";
    iframe.referrerPolicy = "strict-origin-when-cross-origin";
    iframe.allowFullscreen = true;
    iframe.style.opacity = "0";
    const status = document.createElement("div");
    status.className = "ug-video-start ug-loading";
    status.setAttribute("role", "status");
    status.textContent = shell.dataset.ugLoading;
    button.remove();
    shell.append(iframe, status);
    let complete = false;
    let timer;
    const cleanup = () => {
      clearTimeout(timer);
      window.removeEventListener("message", onMessage);
    };
    const fallback = () => {
      if (complete) return;
      complete = true;
      cleanup();
      iframe.remove();
      status.remove();
      const link = document.createElement("a");
      link.className = "ug-video-start ug-fallback";
      link.href = url;
      link.target = "_blank";
      link.rel = "noopener noreferrer";
      const mark = document.createElement("span");
      mark.className = "ug-play";
      mark.setAttribute("aria-hidden", "true");
      mark.textContent = "↗";
      const label = document.createElement("span");
      label.textContent = shell.dataset.ugFallback;
      const help = document.createElement("small");
      help.textContent = shell.dataset.ugFallbackHelp;
      link.append(mark, label, help);
      shell.append(link);
    };
    function onMessage(event) {
      if (event.origin !== "https://www.tiktok.com" || event.source !== iframe.contentWindow) return;
      const message = event.data;
      if (!message || message["x-tiktok-player"] !== true) return;
      if (message.type === "onPlayerReady") {
        complete = true;
        cleanup();
        iframe.style.opacity = "1";
        status.remove();
      } else if (message.type === "onPlayerError" || message.type === "onError") {
        fallback();
      }
    }
    window.addEventListener("message", onMessage);
    timer = setTimeout(fallback, 12000);
  });
})();
